<template>
  <v-container>
    <h1>Account Settings</h1>

    <div class="grid-wrapper">
      <Navigation
        :activePage="activePage"
        :pages="pages"
        @selected="activePage = $event" />

      <UserInfo v-if="activePage === 'Personal Information'" />
      <UserPassword v-if="activePage === 'Password'" />
    </div>
  </v-container>
</template>

<script>
import Navigation from './Navigation'
import UserInfo from './UserInfo'
import UserPassword from './UserPassword'

export default {
  name: 'Account',
  components: {
    Navigation,
    UserInfo,
    UserPassword,
  },
  data: () => ({
    activePage: 'Personal Information',
    pages: [
      'Personal Information',
      'Password',
    ],
  }),
}
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 30px;

  color: $textDarkMuted;
  font-family: "Sansation Regular", sans-serif;
  font-weight: normal;
}

.grid-wrapper {
  width: 100%;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;

  grid-column-gap: 50px;
  grid-row-gap: 30px;

  align-items: flex-start;

  @include lg {
    grid-template-columns: auto 1fr;
    grid-template-rows: 1fr;
  }
}

::v-deep {
  h2 {
    font-size: 22px;
    line-height: 26px;
    color: $textDarkMuted;
    margin-bottom: 50px;
  }

  .input-grid {
    margin: 20px 0;
    display: grid;

    grid-template-columns: 1fr;
    grid-template-rows: auto;

    grid-column-gap: 30px;
    align-items: center;

    label {
      margin: 15px 0 5px;
      font-weight: bold;

      &:first-of-type { margin-top: 0; }
    }

    @include md {
      grid-template-columns: auto 1fr;
      grid-template-rows: auto;

      grid-row-gap: 30px;
      grid-column-gap: 30px;
      align-items: center;

      label {
        margin: 0;
        font-weight: normal;

        &.editing { margin-top: -20px; }
      }
    }

    & + .button-group {
      justify-content: flex-end;
    }
  }

  label, .field-label {
    font-family: "Sansation Regular", sans-serif;
    font-size: 18px;
    line-height: 21px;
    color: $textDarkMuted;
  }

  .v-input__slot {
    margin-bottom: 0 !important;
  }
}
</style>
